import { render } from "./Paths.vue?vue&type=template&id=dae749e0&scoped=true&ts=true"
import script from "./Paths.vue?vue&type=script&lang=ts"
export * from "./Paths.vue?vue&type=script&lang=ts"

import "./Paths.vue?vue&type=style&index=0&id=dae749e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae749e0"]])

export default __exports__